import { getDashColor } from '../../styles'
import { DASHCOLORS } from 'bd-web-components'
import {
  WHITE,
  PRIMARY_BLUE_02,
  GRAY_SCALE_09,
  GRAY_SCALE_04,
  PRIMARY_BLUE_03,
  PRIMARY_BLUE_07,
  SECONDARY_BLUE_10,
  GRAY_SCALE_01,
} from 'bd-web-components/src/utils/dash-colors'

import styled, { css } from 'styled-components'

interface ExceptionContainerProps {
  height: number
  margin: boolean
}

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 1325px;
  margin: 0 auto;
  margin-bottom: 162px;
  margin-top: 40px;
  padding: 0px 64px;
  @media (max-width: 768px) {
    padding: 0px 24px;
  }
`

export const PageTitle = styled.h4`
  color: ${DASHCOLORS.PRIMARY_BLUE_02};
  font-size: 32px;
  font-style: normal;
  font-weight: 700;
  line-height: 35.2px; /* 110% */
  margin-bottom: 19px;
  @media (max-width: 768px) {
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 22px; /* 110% */
    margin-bottom: 13px;
  }
`

export const MonthTitle = styled.p`
  color: ${PRIMARY_BLUE_02};
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 22.4px;
  margin-bottom: 24px;
`

export const PageSubtitle = styled.p`
  color: ${getDashColor('GRAY_SCALE_05', 'GRAY_DARK')};
  font-size: 16px;
  opacity: 0.6;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  @media (max-width: 768px) {
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
`

export const CardTitle = styled.p`
  color: ${PRIMARY_BLUE_02};
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 25.2px;

  &.error {
    color: ${PRIMARY_BLUE_03};
  }
`

export const CardDescription = styled.div`
  display: flex;
  color: ${PRIMARY_BLUE_02};
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;

  &.error {
    color: ${GRAY_SCALE_01};
    font-size: 12px;
    font-weight: 400;
  }
`

export const FormDivider = styled.div`
  background-color: ${getDashColor('GRAY_SCALE_08', 'BEIGE')};
  width: 100%;
  height: 2px;
  margin-top: 29px;
  @media (max-width: 768px) {
    margin-top: 29px;
  }
`

export const Divider50 = styled.div`
  background-color: ${getDashColor('GRAY_SCALE_08', 'BEIGE')};
  width: 50%;
  height: 2px;
  margin: 24px 0;
  @media (max-width: 768px) {
    width: 100%;
  }
`

export const Divider25 = styled.div`
  background-color: ${getDashColor('GRAY_SCALE_08', 'BEIGE')};
  width: 25%;
  height: 2px;
  margin: 24px 0;
`

export const FirstStepButtonBox = styled.div`
  width: 200px;
`

export const TextHeaderBox = styled.div`
  width: 100%;
`

export const ExceptionContainer = styled(styled.div``) <ExceptionContainerProps>`
  display: flex;
  justify-content: center;
  align-items: center;

  ${(props) =>
    props.height !== undefined &&
    css`
      height: ${props.height}px;
    `}
  ${(props) =>
    props.margin &&
    css`
      margin-bottom: 100px;
    `}
`

export const ButtonDescription = styled.div`
  padding: 0 32px;
`

export const ContainerButtons = styled.div`
  display: flex;
`

export const ContainerCard = styled.div`
  width: 184px;
  margin-right: 8px;
  cursor: pointer;
  @media (max-width: 762px) {
    width: 100%;
  }
`

export const DetailCard = styled.div`
  display: flex;
  height: 58px;
  width: 184px;
  border: 1px solid ${GRAY_SCALE_09};
  border-radius: 5px;
  padding: 30px;
  margin: 8px;

  @media (max-width: 762px) {
    width: 100%;
  }
`

export const LabelCard = styled.div`
  color: ${GRAY_SCALE_04};
  text-align: center;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin: 0px 8px;
`

export const IconDetailContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-around;
  &:before {
    content: '';
    width: 38px;
    height: 38px;
    background-color: ${SECONDARY_BLUE_10};
    border-radius: 100px;
    position: absolute;
    z-index: 0;
  }
  & div {
    z-index: 1;
  }
`

export const BalanceAvailableButton = styled.div`
  cursor: pointer;
  max-width: 280px;
`

export const BalanceAvailable = styled.div`
  color: ${PRIMARY_BLUE_03};
  font-size: 32px;
  font-style: normal;
  font-weight: 700;
  line-height: 35.2px;
  margin-top: 16px;
  max-width: 280px;
`

export const BalanceAvailableLabel = styled.div`
  color: ${PRIMARY_BLUE_07};
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 22.4px;
  margin-top: 32px;
  margin-bottom: 16px;
  max-width: 280px;
  display: flex;
  justify-content: space-between;
`

export const BalanceAvailableIcon = styled.div`
  text-align: right;
  top: 25px;
  position: relative;
`

export const BalanceLabel = styled.div`
  display: flex;
  align-items: baseline;
  color: ${PRIMARY_BLUE_07};
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 19.6px;
`

export const BalanceValue = styled.div`
  color: ${PRIMARY_BLUE_03};
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 22.4px;
  margin-bottom: 24px;
  padding: 0 5px;
`

export const DateManager = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 39px;
  margin-bottom: 40px;
  @media (max-width: 530px) {
    margin-top: 36px;
    justify-content: flex-start;
    align-items: flex-start;
    flex-direction: column;
  }
`
export const InputContainer = styled.div`
  @media (max-width: 530px) {
    width: 100%;
    margin-top: 30px;
  }
`

export const SelectDateContainer = styled.div`
  display: flex;
  gap: 30px;
  font-weight: 500;
  position: relative;
  justify-content: space-between;
  &:before {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 3px;
    background-color: ${getDashColor('GRAY_SCALE_08', 'BEIGE')};
  }
  @media (max-width: 530px) {
    width: 100%;
  }
`

export const SelectDateText = styled.div`
  align-items: center;
  display: flex;
  height: 50px;
  cursor: pointer;
  position: relative;
  white-space: nowrap;
  color: ${getDashColor('GRAY_SCALE_05', 'GRAY_DARK')};
  font-weight: 400;
  &.active {
    color: ${getDashColor('BLACK', 'GRAY_DARK')};
    font-weight: 700;
  }
  &:hover {
    color: ${getDashColor('BLACK', 'GRAY_DARK')};
    font-weight: 700;
  }
  &:hover::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 3px;
    background-color: ${getDashColor('PRIMARY_RED_01', 'SECONDARY_COLOR')};
  }
  &.active::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 3px;
    background-color: ${getDashColor('PRIMARY_RED_01', 'SECONDARY_COLOR')};
  }
`

export const EventCard = styled.div`
  width: 100%;
  height: 120px;
  flex-shrink: 0;
  border-radius: 10px;
  border: 2px solid ${getDashColor('GRAY_SCALE_08', 'BEIGE')};
  background: ${WHITE};
  /* box-shadow: 0px 4px 21px 0px rgba(0, 0, 0, 0.08); */
  padding: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;

  @media (max-width: 768px) {
    flex-direction: column;
    height: auto !important;
  }

  &.error {
    height: 224px;
  }
`

export const CardContent = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 18px;
  flex: 1;

  @media (max-width: 768px) {
    width: 100%;
    margin: 18px 0;
  }
`

export const CardButton = styled.div`
  display: flex;
  width: 204px;

  @media (max-width: 768px) {
    width: 100%;
  }
`

export const ImgEvent = styled.img`
  width: 200px;
  height: 81px;
  object-fit: cover;
  @media (max-width: 768px) {
    width: 100%;
    height: auto;
  }
`

export const DividerH = styled.div`
  width: 2px;
  height: 17px;
  border-radius: 1px;
  background-color: ${GRAY_SCALE_04};
  margin: 0 16px;
`

export const ErrorBox = styled.div`
  margin: 20px 0;
  width: 224px;
`

export const ShowEventButton = styled.div`
  border-radius: 100px;
  color: ${getDashColor('WHITE', 'BLACK')};
  border: 1px solid ${getDashColor('SECONDARY_BLUE_06', 'BLACK')};
  background-color: ${getDashColor('SECONDARY_BLUE_06', 'WHITE')};
  font-size: 14px;
  text-align: center;
  padding: 16px;
  cursor: pointer;
  height: 48px;
  width: 100%;

  &:hover {
    background-color: ${getDashColor('SECONDARY_BLUE_05', 'SECONDARY_COLOR')};
    border-color: ${getDashColor('SECONDARY_BLUE_05', 'SECONDARY_COLOR')};
    color: white;
  }
`